import { render, staticRenderFns } from "./login-table.vue?vue&type=template&id=20cb7fdb"
import script from "./login-table.vue?vue&type=script&lang=js"
export * from "./login-table.vue?vue&type=script&lang=js"
import style0 from "./login-table.vue?vue&type=style&index=0&id=20cb7fdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports